import React from 'react';
import cn from 'classnames';

export function FormError({ message, right=false }) {
    if (!message) {
        return null;
    }
    return <div className={cn("form-error", {"form-error-right": right})}>{message}</div>;
}
